import { Text } from "@chakra-ui/react";
import { ReactNode } from "react";

const StepTitle = ({ children }: { children: ReactNode }) => {
  return (
    <Text mb="8px" fontWeight="600" fontSize="20px">
      {children}
    </Text>
  );
};

export default StepTitle;
